import { render, staticRenderFns } from "./DeliveryNoteList.vue?vue&type=template&id=2d4e6ee9&lang=pug&"
import script from "./DeliveryNoteList.vue?vue&type=script&lang=ts&"
export * from "./DeliveryNoteList.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryNoteList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports